import type { OrderStatusId } from '@witmetrics/utils';
import { ORDER_STATUS_ID } from '@witmetrics/utils/constants';

const { PENDING, FULFILLED, CANCELED, RETURNED, IN_PROGRESS, ACCEPTED } =
  ORDER_STATUS_ID;

export const classes = {
  label:
    'inline-flex items-center rounded-full px-[9px] py-[3px] text-[11px] font-semibold leading-none tracking-[0.03em]',
};

export function getStatusColors(orderStatusId: OrderStatusId) {
  const colors = {
    [PENDING]:
      'text-[#7a5d00] bg-[#eab308]/[0.32] dark:text-[#f5c542] dark:bg-[#eab308]/[0.22]',
    [FULFILLED]:
      'text-[#15803d] bg-[#22c55e]/[0.18] dark:text-[#5be08a] dark:bg-[#22c55e]/[0.2]',
    [CANCELED]:
      'text-[#dc2626] bg-[#ef4444]/[0.15] dark:text-[#f87171] dark:bg-[#ef4444]/[0.18]',
    [RETURNED]:
      'text-[#c2570c] bg-[#f97316]/[0.18] dark:text-[#fb923c] dark:bg-[#f97316]/[0.2]',
    [IN_PROGRESS]:
      'text-[#a21caf] bg-[#c026d3]/[0.15] dark:text-[#e879f9] dark:bg-[#c026d3]/[0.22]',
    [ACCEPTED]:
      'text-[#0f766e] bg-[#0d9488]/[0.16] dark:text-[#2dd4bf] dark:bg-[#0d9488]/[0.22]',
  };
  return colors[orderStatusId];
}
